export enum EcpLocatorEvent {
  ClinicAddress = 'Loc_OfflineClinicAddress',
  PhoneCall = 'Loc_PhoneCall',
  MapIcon = 'Loc_OfflineMapIcon',
  LensomatShowAssortment = 'Loc_Vending_Products',
  OrderLenses = 'Loc_OrderLenses',
  LensFitting = 'Loc_Offline_LensFitting',
  SelectDateForFitting = 'Loc_SelectDateForFitting',
  ChangeFittingDate = 'Loc_ChangeFittingDate',
  RequestFitting = 'Loc_RequestFitting',
  ReviewFittingRequest = 'Loc_ReviewFittingRequest',
  CancelFitting = 'CancelFitting',
  CataractRequestConsulting = 'Loc_Cataract_RequestConsulting',
  CataractCall = 'Loc_Cataract_Call',
}

export enum BannerEvent {
  RegMainBonus = 'Reg_Main_Bonus',
  RegMainBannerViewBonus = 'Reg_Main_Banner_ViewBonus',
}